const validatePassword = (pass) => {
  const errors = [];

  if (pass.length === 0) {
    errors.push("Password is required field");
  }
  if (pass.length < 8) {
    errors.push("Password must be at least 8 characters long");
  }

  if (!/[A-Z]/.test(pass)) {
    errors.push("Password must contain at least one uppercase letter");
  }

  if (!/[a-z]/.test(pass)) {
    errors.push("Password must contain at least one lowercase letter");
  }

  if (!/[0-9]/.test(pass)) {
    errors.push("Password must contain at least one number");
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pass)) {
    errors.push("Password must contain at least one special character");
  }

  return errors;
};
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const emailRegex2 = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const usernameRegex = /^[a-zA-Z0-9]{3,}$/;

const validationPatterns = {
  firstName: /^[A-Za-z\s'-]{3,50}$/,
  lastName: /^[A-Za-z\s'-]{1,50}$/,
  middleName: /^[A-Za-z\s'-]{1,50}$/,
  mobileNumber: /^\d{10}$/,
  panNumber: /^\d{6}$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  username:
    /^([a-zA-Z0-9]{3,}$)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
  address: /^[A-Za-z0-9\s,.'-]{1,100}$/,
  countryCode: /^[A-Z]{2}$/,
  postcode: /^[A-Za-z0-9\s-]{3,12}$/,
  state: /^[A-Za-z\s'-]{1,50}$/,
  city: /^[A-Za-z\s\.\-']+$/,
  nationality: /^[A-Z]{2}$/,
  dob: /^\d{4}-\d{2}-\d{2}$/,
  pan: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
};

const validateField = (field, value) => {
  switch (field) {
    case "first_name":
      if (!value) return "Payee name is required.";
      if (value.length < 2) return "Name must be at least 2 characters.";
      if (value.length > 50) return "Name cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s]+$/.test(value))
        return "Name can only contain letters and spaces.";
      return "";
    case "last_name":
      if (!value) return "Payee last name is required.";
      if (value.length < 2) return "Name must be at least 2 characters.";
      if (value.length > 50) return "Name cannot exceed 50 characters.";
      if (!/^[a-zA-Z\s]+$/.test(value))
        return "Name can only contain letters and spaces.";
      return "";
    case "postcode":
      if (!value) return "Postal code is required.";
      // if (!/^\d{5}(-\d{4})?$/.test(value)) return "Invalid postal code format.";
      return "";
    case "entity_type":
      if (!value) return "Payee Type is required.";

      return "";
    case "country_code":
      if (!value) return "Payee Country is required.";

      return "";

    case "state":
    case "city":
      if (!value) return `${field === "state" ? "State" : "City"} is required.`;
      if (value.length < 2)
        return `${
          field === "state" ? "State" : "City"
        } must be at least 2 characters.`;
      if (value.length > 50)
        return `${
          field === "state" ? "State" : "City"
        } cannot exceed 50 characters.`;
      if (!/^[a-zA-Z\s]+$/.test(value))
        return `${
          field === "state" ? "State" : "City"
        } can only contain letters and spaces.`;
      return "";
    case "street_address":
      if (!value) return "Address is required.";
      if (value.length < 5) return "Address must be at least 5 characters.";
      if (value.length > 200) return "Address cannot exceed 200 characters.";
      return "";
    default:
      return "";
  }
};

const validateFieldSecond = (field, value) => {
  // If field is not required and value is empty, no error
  if (!field?.required && !value) return "";

  // Required field check
  if (field?.required && !value) {
    return `${field.displayName} is required`;
  }

  if (field?.validation) {
    if (field.displayName !== "state") {
      // if (field?.validation.includes("|")) {
      //   // For enum-like validations
      //   const validOptions = field?.validation.split("|");
      //   return validOptions?.includes(value)
      //     ? ""
      //     : `Invalid ${field.displayName}`;
      // }

      // For regex validations
      const validationRegex = new RegExp(field.validation);
      return validationRegex.test(value) ? "" : `Invalid ${field.displayName}`;
    }
  }
  return "";
};

export {
  validatePassword,
  emailRegex2,
  usernameRegex,
  validationPatterns,
  emailRegex,
  validateField,
  validateFieldSecond,
};
